import React from 'react'
import * as R from 'ramda'

import './sidecar-icons/style.css'
import reactSupportedEvents from './utils'

const Icon = ({
  className,
  lineHeight,
  margin,
  name,
  onClick,
  size,
  ...otherProps
}) => (
  <span
    className={`${className} sidecon-${name}`}
    style={{
      fontSize: `${(size / 10) * 0.625}rem`,
      lineHeight: `${lineHeight}rem`,
      margin,
    }}
    onClick={onClick}
    data-testid={otherProps['data-testid']}
    {...R.pick(reactSupportedEvents)(otherProps)}
  />
)

export default Icon
